import { Scale } from "@pdfking/math"

import type { CalendarDesign } from "#internal"

import { Slice } from "../../layout/Slice"
import { Area } from "../Area"
import { PictureCover } from "../PictureCover"
import { Region } from "../Region"

/** Milo, a square desk calendar: the year at the foot of its picture; a month under its picture, the logo and the contact left of its name and grid. */
export const Milo: CalendarDesign = {
  cover: PictureCover({ at: 0.05, size: 0.2 }),
  page: ({ gap, language, outer, page, short, year }, month) => {
    const picture = Region(page, 0, 0.55, 1, 1)
    const below = Slice.under(outer, picture.y, gap)
    return [
      Area.picture(picture, month),
      Area.contact(Region(below, 0, 0, 0.26, 1), false),
      ...Area.month(Region(below, 0.32, 0, 1, 1), month, year, language, Scale(short, 0.07), gap),
    ]
  },
  pages: "month",
}
